import * as ActionTypes from 'store/actionTypes';

export const changeSidebarCollapsed = (collapsed: boolean) => ({
  type: ActionTypes.CHANGE_SIDEBAR_COLLAPSED,
  payload: collapsed
});
